import { IField } from 'shared/entities/form';

import { IData } from '../../data';
import {
  BlockBaseNormalized,
  BlockKind,
  BlockNormalizer,
  BlockType
} from '../common';
import { ISqCondition } from '../../condition';

import {
  ActionHttpRequestServer,
  ActionHttpRequestMethod,
  HttpRequestPayloadKind
} from './server';

export type IActionHttpRequestFormPayload = IData;

export interface IActionHttpRequestJsonPayload {
  sq: ISqCondition;
}

export interface IActionHttpRequestPlainPayload {
  data: string;
}

export interface IActionHttpRequestResponse {
  headersVar: IField<string | null>;
  bodyVar: IField<string | null>;
  statusVar: IField<string | null>;
}

export type IActionHttpRequestHeaders = IData;

export enum ActionHttpRequestTab {
  body = 'body',
  headers = 'headers'
}

export interface IActionHttpRequestParams {
  kind: IField<HttpRequestPayloadKind>;
  method: ActionHttpRequestMethod;
  url: IField;
  formPayload: IActionHttpRequestFormPayload;
  jsonPayload: IActionHttpRequestJsonPayload;
  jsonPayloadSq: IActionHttpRequestJsonPayload;
  plainPayload: IActionHttpRequestPlainPayload;
  response: IActionHttpRequestResponse;
  headers: IActionHttpRequestHeaders;
}

export type ActionHttpRequestNormalized = BlockBaseNormalized<
  BlockType.action,
  BlockKind.httpRequest
>;

export type ActionHttpRequestNormalizer = BlockNormalizer<
  ActionHttpRequestServer,
  ActionHttpRequestNormalized
>;
